export function groupLog(...params) {
  // if (isNotProduction()) {
  console.group(...params)
  // }
}

export function groupLogEnd(...params) {
  // if (isNotProduction()) {
  console.groupEnd(...params)
  // }
}

export function verbose(element, ...args) {
  // if (isProduction()) return

  const parent = this
  const { __ref: ref } = parent
  console.groupCollapsed(parent.key)
  if (args.length) {
    args.forEach((v) =>
      console.log(`%c${v}:\n`, 'font-weight: bold', parent[v])
    )
  } else {
    console.log(ref.path)
    const keys = parent.keys()
    keys.forEach((v) => console.log(`%c${v}:`, 'font-weight: bold', parent[v]))
  }
  console.log(parent)
  console.groupEnd(parent.key)
  return parent
}

export function log(...params) {
  // if (isProduction()) return
  console.log(...params)
}

export function warn(...params) {
  // if (isProduction()) return
  const { hostname } = window.location
  if (
    !hostname ||
    hostname === 'localhost' ||
    typeof window.symbols?.faro === 'undefined'
  ) {
    return console.warn(...params, this)
  }
  const { trace, context } = window.symbols.faro.api.getOTEL()
  const tracer = trace.getTracer('frontend-uikit-tracer')
  const span = tracer.startSpan('warning')
  context.with(trace.setSpan(context.active(), span), () => {
    console.warn(...params, this)
    span.end()
  })
}

export function error(...params) {
  // if (isProduction()) return
  const logger = () => {
    const lastParam = params[params.length - 1]
    const hasOpts = typeof lastParam === 'object' && lastParam
    if (hasOpts?.debugger) debugger // eslint-disable-line
    if (hasOpts?.verbose) {
      this.verbose.call(this, ...params)
    }
    if (this.call('isFunction', hasOpts?.onError)) {
      hasOpts?.onError.call(this, ...params)
    }
    console.error(...params, this)
  }
  const { hostname } = window.location
  if (
    !hostname ||
    hostname === 'localhost' ||
    typeof window.symbols?.faro === 'undefined'
  ) {
    return logger()
  }
  const { trace, context } = window.symbols.faro.api.getOTEL()
  const tracer = trace.getTracer('frontend-uikit-tracer')
  const span = tracer.startSpan('error')
  context.with(trace.setSpan(context.active(), span), () => {
    logger()
    span.end()
  })
}
